<template>
	<div>
		<router-view v-if="$route.meta.loginFree || (saasInfo && userInfo)"></router-view>
		<iframe v-if="printPDF" ref="print" :src="printPDF" style="position: fixed; left: 100%; top: 0; width: 0; height: 0;"></iframe>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import {SERVER_ADDR} from '@/config.js'

	export default {
		name: 'App',

		data() {
			return {
				printPDF: ''
			}
		},

		computed: {
			...mapState(['session', 'saasInfo', 'userInfo'])
		},

		watch: {
			$route() {
				this.globalDialogDestroy();
				this._scanListenerEvent = [];
			},

			session: {
				handler(val) {
					if (!val) {
						this.$store.commit('setSystemConfig', null);
						this.$store.dispatch('updateSystemConfig');
					}
				},
				immediate: true
			},

			'userInfo.saas_id': {
				handler(val) {
					if (val) {
						this.$store.dispatch('updateFieldConfig');
					}
				},
				immediate: true
			}
		},

		created() {
			document.body.ondrop = function (event) {
				event.preventDefault();
				event.stopPropagation();
			}
			this.session && this.$store.dispatch('updateLoginInfo');
			
			this._scanListenerInput = [];
			this._scanListenerEvent = [];
			this._scanText = '';
			this._lastKeyTime = 0;
			document.addEventListener('keydown', e => {
				if (!e.key) return;
				if (document.activeElement.tagName == 'BUTTON') {
					e.preventDefault();
				}
				let now = Date.now();
				if (now - this._lastKeyTime > 100) {
					this._scanText = '';
				}
				this._lastKeyTime = now;

				if (e.key.length == 1) {
					this._scanText += e.key;
				}
			});
			document.addEventListener('keyup', e => {
				if (!e.key) return;
				if (e.key == 'Enter' && this._scanText) {
					e.stopImmediatePropagation();
					let text = this._scanText;
					this._scanText = '';
					this.scanHandle(text);
				}
			}, true);
		},

		methods: {
			print(src) {
				clearTimeout(this._printTimer);
				this.printPDF = '';
				let loading = this.$loading({
					message: '数据文件加载中...'
				});
				this.$nextTick(() => {
					this.printPDF = SERVER_ADDR + src;
					this.$nextTick(() => {
						this.$refs.print.onload = () => {
							loading.$loadOver();
							try {
								this.$refs.print.contentWindow.print();
							} catch(e) {
								window.open(this.printPDF);
							}

							this._printTimer = setTimeout(() => {
								this.printPDF = '';
							}, 30000);
						};
					});
				});
			},

			scanHandle(text) {
				if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName) && !/^https?:\/\/.+$/.test(text)) {
					document.activeElement.value = text;
					document.activeElement.dispatchEvent(new Event('input', {bubbles: true}));
					document.activeElement.dispatchEvent(new Event('change', {bubbles: true}));
					document.activeElement.dispatchEvent(new KeyboardEvent('keyup', {key: 'Enter', code: 'Enter', keyCode: 13, bubbles: true, cancelable: true}));
				} else {
					if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
						document.activeElement.value = '';
						document.activeElement.dispatchEvent(new Event('input', {bubbles: true}));
						document.activeElement.dispatchEvent(new Event('change', {bubbles: true}));
					}
					this._scanListenerInput.filter(el => {
						let style = getComputedStyle(el);
						return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
					}).forEach(el => {
						let $vm = el.__vue__;
						$vm.set(text);
						$vm.$emit('change', text);
						$vm._scanCallback && $vm._scanCallback(text);
						$(el).find('input, textarea')[0].dispatchEvent(new KeyboardEvent('keyup', {key: 'Enter', code: 'Enter', keyCode: 13, bubbles: true, cancelable: true}));
					});
					this._scanListenerEvent.forEach(event => event(text));
				}
			},

			registerScanInput(el) {
				if (!this._scanListenerInput.includes(el)) {
					this._scanListenerInput.push(el);
				}
			},

			registerScanEvent(fun) {
				this._scanListenerEvent.push(fun);
			}
		}
	}
</script>

<style lang="stylus">
	@import './assets/style/reset';
	@import './assets/style/fonts';

	@media print {
		body .g-page,
		.c-notice,
		.c-message,
		.c-popup-mask,
		.c-dialog-wrapper {
			display: none;
		}

		.print-body {
			display: block !important;
		}
		.print-page {
			box-sizing: border-box;
			overflow: hidden;
			font-size: 10pt;

			&:nth-last-child(n+2) {
				page-break-after: always;
			}

			&[border="0"] {
				table, td {
					border-color: #fff;
				}
			}
			
			table {
				width: 100%;
				max-width: 100%;
				border: .2mm solid #000;

				td {
					vertical-align: middle;
					border: .2mm solid #000;
					padding: 1.5mm;
					word-break: break-all;

					img {
						vertical-align: middle;
					}
				}
			}	
		}
	}
	
	.c-input,
	.c-select,
	.c-datetime,
	.c-poly-upload-main,
	.c-poly-upload-input {
		box-shadow: inset 0 2px 4px #eee;
	}
	.m-search-item,
	.c-table-body {
		.c-input,
		.c-select,
		.c-datetime,
		.c-poly-upload-input {
			box-shadow: none;
		}
	}

	.g-page .g-content {
		background: #F0F2F5 !important;
	}

	.c-button {
		.icon {
			line-height: 1.1;
			font-size: 1.2em;
		}
	}
	
	.c-module-content {
		> .c-title {
			padding: 0 20px;
		}

		> .c-table:nth-child(1) {
			margin-top: -1px;
		}
	}
	
	.c-table-body {
		.c-input {
			height: 30px;
			background: #FFFAAD;
			
			input {
				padding: 0 5px !important;
				font-size: 13px !important;
			}

			textarea {
				height: 28px !important;
				min-height: 28px !important;
				padding: 4px 5px !important;
				font-size: 13px !important;
			}
		}
		
		.c-select {
			height: 30px;
			background: #FFFAAD;
			
			&-main {
				padding-left: 5px;
			}
			
			&-current {
				font-size: 13px;
			}

			&-icon,
			&-clear {
				min-width: 24px;
			}
			
			input {
				background: none;
			}
		}

		.c-datetime {
			height: 30px;
			background: #FFFAAD;

			&-icon,
			&-clear {
				min-width: 24px;
			}
			&-line {
				width: 26px;
				min-width: 26px;
			}
			
			input {
				font-size: 13px;
			}
		}

		.c-poly-upload-input {
			min-height: 30px !important;
			padding-left: 2px !important;
			background: #FFFAAD !important;

			&-list {
				padding: 2px 0 !important;

				.c-file-media {
					width: 24px !important;
					height: 24px !important;
					margin-right: 2px !important;
				}
			}

			&-icon {
				min-width: 24px !important;
			}
		}

		.c-switch {
			display: block;
		}

		.c-formula {
			padding: 4px 0 4px 5px !important;
			line-height: 20px !important;
			font-size: 13px !important;
		}
	}
	
	.c-table table thead tr th {
		padding-left: 5px;
		padding-right: 5px;
	}
	.c-table table tbody tr td {
		padding: 5px;
	}

	.c-table-button-more ul {
		box-shadow: 0 0 10px 0 rgba(0,0,0,.15);

		li {
			font-size: 13px;
		}
	}

	.c-table-button-item .c-table-button-icon {
		display: none;
	}

	.c-form {
		> .c-title {
			box-sizing: border-box;
			width: 100%;
		}
	}

	.c-pagination {
		height: 40px !important;
	}

	.c-message p {
		max-width: 14em !important;
	}

	.c-form {
		.c-title:nth-child(n+2) {
			margin-top: 10px;
		}
	}

	.c-dialog {
		.c-tab-list ul[type=border-tab] {
			background: #FAFAFA;

			li.z-crt {
				background: linear-gradient(0deg, #FFFFFF 40%, #F2FFFC);
			}
		}
	}

	.m-detail {
		&-tag {
			gap: 6px;
			margin-left: 4px;

			label {
				border: 1px solid #bbb;
				border-radius: 2px;
				padding: 0 6px;
				line-height: 22px;
				font-size: 12px;
				color: #666;
			}
		}

		&-form {
			padding: 0;

			.c-detail-content {
				border: none;
			}

			.c-detail-item {
				border-left: none;

				&-label {
					width: 100px;
				}
			}
		}

		&-box {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			gap: 6px;
			padding: 20px;

			> .c-title:nth-child(n+2) {
				margin-top: 10px;
			}

			> .c-detail {
				padding: 0;
			}

			> .custom-table {
				width: 100%;

				&.flex-grow {
					min-height: 200px;
				}
			}
		}
	}

	.process-group-pre {
		min-width: 14px;

		&:before {
			content: '';
			position: absolute;
			left: 5px;
			top: -1px;
			bottom: -1px;
			border-right: 1px solid #999;
		}
		&[type='first']:before {
			top: 50%;
		}
		&[type='last']:before {
			bottom: 50%;
		}

		&:after {
			content: '';
			position: absolute;
			left: 5px;
			top: 50%;
			width: 10px;
			border-top: 1px solid #999;
		}
	}
</style>